import React, { useContext } from "react";
import { MovieIndexContext } from "../../context/MovieIndexContext";

import "./VideoDesc.scss";

const VideoDesc = ({ content }) => {
  const { movieId } = useContext(MovieIndexContext);
  // console.log("content from VideoDesc.js", content);
  const Overview = { content };
  return (
    <div className="video-desc">
      <div className="video-desc__title">Story</div>
      <div className="video-desc__overview">
        {`"${Overview?.content[movieId]?.overview}"`}
      </div>
    </div>
  );
};

export default VideoDesc;
